import { render } from "./contactus.vue?vue&type=template&id=0bc83708"
import script from "./contactus.vue?vue&type=script&lang=js"
export * from "./contactus.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/afroshe-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__